import { useQuery } from '@tanstack/react-query';
import { ShieldAlert } from 'lucide-react';
import { rulesApi } from '@/api';
import { Card, CardContent } from '@/components/ui/card';

// JSON-колонка из MySQL может прийти как массив или как строка.
function parseItems(v: unknown): string[] {
  if (Array.isArray(v)) return v as string[];
  if (typeof v === 'string') {
    try {
      const p = JSON.parse(v);
      return Array.isArray(p) ? p : [];
    } catch {
      return [];
    }
  }
  return [];
}

export function RulesPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['rules'],
    queryFn: rulesApi.list,
    staleTime: 60_000,
  });

  return (
    <div className="mx-auto max-w-4xl px-6 lg:px-12 py-12">
      <div className="flex items-center gap-3 mb-3">
        <ShieldAlert className="h-8 w-8 text-eol-pink" />
        <h1 className="text-3xl md:text-4xl font-extrabold text-eol-white">Правила сервера</h1>
      </div>
      <p className="text-eol-desc mb-8">
        Незнание правил не освобождает от ответственности. Администрация имеет право
        блокировать аккаунт без предупреждения.
      </p>

      {isLoading ? (
        <p className="text-eol-desc">Загрузка…</p>
      ) : !data || data.length === 0 ? (
        <p className="text-eol-desc">Правила ещё не заполнены.</p>
      ) : (
        <div className="space-y-4">
          {data.map((s) => (
            <Card key={s.id}>
              <CardContent className="pt-6">
                <h2 className="text-xl font-bold text-eol-white mb-3">{s.title}</h2>
                <ul className="space-y-2 text-eol-desc">
                  {parseItems(s.items).map((i, idx) => (
                    <li key={idx} className="flex gap-2">
                      <span className="text-eol-pink">•</span>
                      <span>{i}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
